import { adalApiFetch } from "authProvider";
import { endPoints, API_ROOT } from "appSettings";

export const deleteUserProduct = (email: string, productId: number) => {
  return (dispatch: any) => {
    return adalApiFetch(
      fetch,
      `${API_ROOT}${endPoints.user}/${email}/products/${productId}`,
      {
        method: "DELETE",
        headers: {
          "content-type": "application/json",
        },
      },
      dispatch
    ).then((response: any) => {
      if (!response.ok) {
        return false;
      }
      return true;
    });
  };
};
